import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import PageLayout from "examples/LayoutContainers/PageLayout";
import impresLogo from "../../../assets/ImpLogo.jpg";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "axios";
import { API_ENDPOINTS } from "config/api";
import { encryptText, decryptText } from "config/encryption";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [greetName, setGreetName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // Check for adminsessiondetails in localStorage
    const session = localStorage.getItem("adminsessiondetails");
    if (session) {
      try {
        const decrypted = decryptText(session);
        const parsed = JSON.parse(decrypted);
        if (parsed.Usn) {
          setGreetName(parsed.Usn);
        }
      } catch (e) {
        // If decryption fails, clear session
        localStorage.removeItem("adminsessiondetails");
      }
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const encodedAdminCode = encryptText(username);
      const encodedPassword = encryptText(password);
      const response = await axios.post(
        API_ENDPOINTS.AUTH_ADMIN.STAFF_LOGIN,
        {
          staffCode: encodedAdminCode,
          password: encodedPassword,
        }
      );
      if (response && response.data) {
        localStorage.setItem("adminLogsessiondetails", response.data);
        // Greet user after login
        try {
          const decrypted = decryptText(response.data);
          const parsed = JSON.parse(decrypted);
          setGreetName(parsed.Usn || "");
        } catch {
          setGreetName("");
        }
        setError("");
        setTimeout(() => {
          window.location.href = "/AdminHome";
        }, 800);
      } else {
        setError("Invalid response from server.");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto" display="flex" alignItems="center" justifyContent="center">
        <Card sx={{ maxWidth: 400, width: "100%", p: { xs: 2, sm: 4 }, borderRadius: 4, boxShadow: 8, zIndex: 2 }}>
          <MDBox display="flex" flexDirection="column" alignItems="center" mb={2}>
            <MDBox component="img" src={impresLogo} alt="Impres Logo" width={70} mb={1} />
            <MDTypography variant="h4" fontWeight="bold" color="info" textAlign="center" mb={1}>
              Admin Login
            </MDTypography>
            {greetName && (
              <MDTypography variant="h6" color="success" textAlign="center" mb={1}>
                Hi, {greetName}
              </MDTypography>
            )}
            <MDTypography variant="body2" color="text" textAlign="center" mb={2}>
              Welcome back! Please sign in to your admin account.
            </MDTypography>
          </MDBox>
          <form onSubmit={handleLogin}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="AdminCode"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </MDBox>
            {error && (
              <MDTypography color="error" variant="caption" display="block" mb={1} textAlign="center">
                {error}
              </MDTypography>
            )}
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              fullWidth
              disabled={loading}
              sx={{ fontWeight: 600, fontSize: 16, borderRadius: 2 }}
            >
              {loading ? "Signing in..." : "Sign in"}
            </MDButton>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{' '}
                <MDTypography
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  sx={{ cursor: "pointer" }}
                  onClick={() => window.location.href = "/AdminRegister"}
                >
                  Register
                </MDTypography>
              </MDTypography>
            </MDBox>
          </form>
        </Card>
      </MDBox>
    </PageLayout>
  );
};

export default AdminLogin;